import React from 'react';
import Link from 'next/link';
import HeadTitle from '../components/head_title';
import Layout from '../components/layout/layout';
import Api from '../service/api';
import Breadcrumbs from '../components/breadcrumbs';
import TimeoutAlert from '../components/timeout_alert';
import styles from '../styles/forgot_password.module.scss';
import { extractAuthError } from '../utils/error';

export default function ForgotPassword() {
	const [email, setEmail] = React.useState('');
	const [completed, setCompleted] = React.useState(false);
	const [serverError, setServerError] = React.useState<string | null>(null);

	const handleForgotPassword = React.useCallback((e: React.FormEvent) => {
		e.preventDefault()
		Api.auth.forgotPassword(email)
			.then((response) => {
				setCompleted(response.data.success)
			})
			.catch(error => {
				setServerError(extractAuthError(error))
			})
	}, [email]);

	let content;
	if (!completed) {
		content = (
			<form onSubmit={handleForgotPassword}>
				<div className="form-group">
					<label className="font-weight-semibold form-label">
						Enter your Email and we will send you a link to reset your password.
					</label>
					<input
						type="text"
						className="form-control"
						name="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						placeholder="Enter email address"
						autoFocus={true}
					/>
				</div>

				<button type="submit" className="btn btn-primary text-uppercase font-weight-bold">Request Password Reset</button>
			</form>
		);
	} else {
		content = (
			<div>
		      <p>You have successfully requested a password reset, an email with instruction should arrive at your email address if your email address is correct.</p>
		      <Link href="/" className="btn btn-primary">Go to Home page</Link>
		    </div>
		);
	}

	return <Layout>
		<HeadTitle title="Forgot Password?" />

		<TimeoutAlert
			message={serverError}
			onHide={() => setServerError(null)}
		/>

		<Breadcrumbs
			currentPage="Forgot Password?"
		/>
		<div className={styles.innerContainer}>
			<div className="row">
				<div className="col-0 col-sm-3">
					<img src="/images/forgot-password-illustration.png" alt="illustration" />
				</div>
				<div className="col-sm-9">
					<h2 className="text-primary">Forgot Password?</h2>
					{content}
				</div>
			</div>
		</div>
	</Layout>
}

export { basicGetStaticProps as getStaticProps } from '../lib/static_props'